import { createGlobalStyle } from 'styled-components'
import { TYPOGRAPHY } from 'styles'

const GlobalStyles = createGlobalStyle`
  :root {
    --base: 16;
    /* --h1: 6rem; // 96/16 */
    --h1: calc((96 / var(--base)) * 1rem);
    --h2: calc((60 / var(--base)) * 1rem);
    --h3: calc((48 / var(--base)) * 1rem);
    --h4: calc((34 / var(--base)) * 1rem);
    --h5: calc((24 / var(--base)) * 1rem);
    --h6: calc((20 / var(--base)) * 1rem);
    --bgDefault: #e6e6e6;
    --primary: #505050;
    --secondary: #1f1f1f;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    // 16px funciona bem para desktop, mas para mobile é necessário deixar em porcentagem
    font-size: calc(var(--base, 16px) * 1px);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html, body, #__next {
    height: 100%;
  }

  /* body, input, textarea, select, button {
    font-family: ${TYPOGRAPHY.primary} !important;
    line-height: 1.4;
  } */

  body {
    background-color: ${({ theme }) =>
      theme.colors.background.contrast} !important;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  // Typography
  /* h1, h2, h3, h4, h5, h6 {
    font-family: ${TYPOGRAPHY.secondary};
    line-height: 120%;

    i {
      margin-top: 1px;
    }
  } */

  // Table
  .tbl-actions-col {
    display: flex;

    > * {
      &:not(:last-of-type) {
        margin-right: 16px;
      }
    }
  }

  .after-confirmation-payer-modal[role='dialog'] {
    overflow: visible;
  }

`

export default GlobalStyles
